import { Card, Chip, Modal, ModalContent, useDisclosure } from '@nextui-org/react'
import SelectTank from '../../pages/SelectTank'
import { useBatchStore } from '../../store/batch/useBatchStore'
import useHomeGradeStore from '../../store/home/useHomeGradeStore'
import type { SelectedTankArray } from '@/types/view'

export const SelectArrivalTanks = () => {
  const {
    isOpen: isOpenArrTanks,
    onOpen: onOpenArrTanks,
    onOpenChange: onOpenChangeArrTanks,
  } = useDisclosure()
  const { depBatchId, selectArrTanksBorderColor, selectedArrTanks, setSelectedArrTanks } =
    useHomeGradeStore()
  const batches = useBatchStore((state) => state.batches)
  const allGroupIds = Object.keys(batches).filter(
    (batchId) => batchId !== '$empty' && batchId !== '$ungrouped',
  )

  return (
    <>
      {depBatchId ? (
        <div className="mt-3 font-bold">Arrival Tanks</div>
      ) : (
        <div className="mt-3 font-semibold text-tdpllightgrey">
          Arrival Tanks <span className="text-xs ">**Please select Departure Tank first</span>
        </div>
      )}
      <Card
        key="arrival"
        className={`${selectArrTanksBorderColor} border-opacity-60`}
        radius="md"
        shadow="sm"
        isPressable={depBatchId !== null}
        onPress={onOpenArrTanks}
        isDisabled={depBatchId === null}
      >
        <Modal
          isOpen={isOpenArrTanks}
          onOpenChange={onOpenChangeArrTanks}
          isDismissable={false}
          isKeyboardDismissDisabled={true}
          size="3xl"
          scrollBehavior="inside"
          classNames={{
            wrapper: 'z-[1500]',
            backdrop: 'z-[1450]',
            base: 'max-h-[85vh] sm:max-h-[90vh] md:max-h-[95vh]',
          }}
        >
          <ModalContent>
            {(onCloseTanks) => (
              <SelectTank
                key="arrival"
                submitTankArray={(tankSelectedList: SelectedTankArray) =>
                  setSelectedArrTanks(tankSelectedList)
                }
                groupIds={[...allGroupIds, '$empty', '$ungrouped']}
                onClose={onCloseTanks}
                initialTankArray={selectedArrTanks}
              />
            )}
          </ModalContent>
        </Modal>
        <div
          className="flex flex-row flex-wrap justify-start p-1 min-h-[6rem] sm:min-h-[2.375rem] overflow-y-auto"
          style={{ touchAction: 'pan-y', WebkitOverflowScrolling: 'touch' }}
          onClick={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
        >
          {selectedArrTanks.map((item, index) => (
            <Chip
              key={index}
              radius="md"
              classNames={{
                base: `border-small border-tdpldarkgrey bg-${item.batchName === '$empty' ? 'tdpllightgrey' : 'tdplsky'} border-opacity-60 m-1 p-0`,
                content: 'font-bold',
              }}
              data-testid={`arrival-tank-chip-${item.tankId}`}
            >
              {item.tankName}
            </Chip>
          ))}
        </div>
      </Card>
      {selectArrTanksBorderColor.includes('tdplmaroon') ? (
        <p className="m-0 text-sm font-semibold text-tdplmaroon">Please select Arrival Tanks.</p>
      ) : (
        <p></p>
      )}
    </>
  )
}
